<template>
  <div class="body__container--carousel">
    <div class="facial-container">
      <span class="countdown-camera" v-if="countdown > 0">{{ countdown }}</span>
      <video
        v-if="!previewImage"
        ref="videoElement"
        class="camera-feed"
        autoplay
        playsinline
      ></video>
      <img v-else-if="previewImage" :src="previewImage" class="camera-feed" />
    </div>
    <div style="display: flex; justify-content: space-between; width: 55%; height: 15px;">
      <button
        class="link-btn"
        v-if="isShown"
        @click="$emit('onTryAgain')"
        :disabled="attempts == 0"
      >
        Tirar outra foto
      </button>
      <button
        class="link-btn"
        v-if="isShown"
        :disabled="attempts == 0"
        @click="$emit('onNext')"
      >
        Prosseguir
        <img src="../../public/img/chevron-left-solid.svg" alt="Seta para a direita" v-if="attempts > 0" />
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["countdown", "previewImage", "isShown", "attempts", "isSuccess"],
  emits: ["onTryAgain", "onNext"],
};
</script>

<style scoped>
.body__container--carousel {
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  position: absolute;
  top: 0;
  right: 0px;
}

.facial-container {
  width: 55%;
  height: 75%;
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  justify-content: start;
  align-items: start;
  background-color: rgb(27, 27, 27);
}

.countdown-camera {
  position: absolute;
  top: 30%;
  left: 45%;
  /* width: 100%; */
  /* height: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8vw;
  font-weight: bold;
  color: #c9c3c26b;
}

.camera-feed {
  width: 100%;
  height: 100%;
  /* height: 70%; */
  object-fit: cover;
  display: block;
  border: 3px solid #edf0f8;
  border-radius: 3px;
}

.link-btn {
  color: #de3012;
  background-color: transparent;
  border: none;
  font-weight: 500;
  font-size: 18px;
  padding: 15px 0px;
  cursor: pointer;

  img{
    width: 9px;
    margin-left: 5px;
    transform: scaleX(-1);
  }

  &:disabled {
    color: #c9c3c2;
    cursor: not-allowed;
  }

  &:hover{
        text-decoration: underline;
  }
}
</style>
